import type { Socket } from "socket.io-client";

interface ClientStore {
	socket?: Socket;
	playerId?: string | null;
}

const store: ClientStore = {};

export default store;
